import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate('/admin');
    });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) {
      setError('E-posta veya şifre hatalı.');
    } else {
      navigate('/admin');
    }
    setLoading(false);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: '100vh', backgroundColor: '#220d1c' }}
    >
      <div className="card p-5 shadow" style={{ width: '100%', maxWidth: '420px' }}>
        <div className="text-center mb-4">
          <img src="/images/konf_logo.png" alt="Logo" style={{ maxHeight: '80px' }} />
          <h4 className="mt-3 mb-0">Admin Girişi</h4>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">{error}</div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">E-posta</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Şifre</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
            style={{ backgroundColor: '#742640', borderColor: '#742640' }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Giriş yapılıyor...
              </>
            ) : 'Giriş Yap'}
          </button>
        </form>

        <div className="text-center mt-4 p-3 rounded" style={{ backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.15)' }}>
          <div className="d-flex align-items-center justify-content-center mb-2">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px', flexShrink: 0 }}>
              <circle cx="12" cy="12" r="12" fill="#00e676"/>
              <path d="M10.2 15.6l-3.6-3.6 1.4-1.4 2.2 2.2 5.8-5.8 1.4 1.4-7.2 7.2z" fill="#ffffff"/>
            </svg>
            <span style={{ color: '#fff', fontWeight: 500 }}>Güvenli Ödeme</span>
          </div>
          <a href="https://www.paratika.com.tr" target="_blank" rel="noopener noreferrer">
            <img
              src="/images/paratika-sanal-pos-beyaz-logo.png"
              alt="Paratika Sanal POS"
              style={{ maxHeight: '36px', marginBottom: '8px' }}
            />
          </a>
          <p style={{ color: '#aaa', fontSize: '0.75rem', margin: 0 }}>
            Ödeme işlemleri TCMB faaliyet onaylı ödeme kuruluşu{' '}
            <a href="https://www.paratika.com.tr" target="_blank" rel="noopener noreferrer" style={{ color: '#7c4dff' }}>
              Paratika
            </a>
            'nın güvenli altyapısı üzerinden gerçekleşmektedir.
          </p>
        </div>
      </div>
    </div>
  );
}
